import { Close } from "@shared/ui/icons";
import styles from "./ReportMediaDrawerHeader.module.scss";

interface ReportMediaDrawerHeaderProps {
  title: string;
  subtitle?: string;
  onClose: () => void;
}

export function ReportMediaDrawerHeader({
  title,
  subtitle,
  onClose,
}: ReportMediaDrawerHeaderProps) {
  return (
    <div className={styles.header}>
      <div className={styles.headerContent}>
        <h3 className={styles.title}>{title}</h3>
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
      </div>
      <button onClick={onClose} className={styles.closeButton} type="button">
        <Close size={20} />
      </button>
    </div>
  );
}
